import React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import DefaultTabsBorderedBottom from './component/DefaultTabsBorderedBottom';

const Booking = () => (
  <div>
    <Breadcrumbs
      style={{ marginLeft: '20px', marginBottom: '15px' }}
      aria-label="breadcrumb"
    >
      <Typography sx={{ color: 'text.primary' }}>Restaurant</Typography>
      <Typography sx={{ color: 'text.primary' }}>Booking</Typography>
      {/* <Typography sx={{ color: 'text.primary' }}>Search</Typography> */}
    </Breadcrumbs>
    <DefaultTabsBorderedBottom />
  </div>
  );

export default Booking;
